import styled from 'styled-components';
import { mobile } from '../../../utils/breakpoints';

export const VideoContainer = styled.div`
  width: 100%;
  height: auto;

  video {
    display: block;
    width: 100% !important;
    height: auto !important;
  }

  @media (max-width: ${mobile.max}px) {
    position: relative;
    display: none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ambient-video/styles/ambient-video.style.js